import { useContext, useEffect } from 'react';
import { RoomAssetsContext } from '../context/RoomAssetsContext';
import useContentPages from '../../components/RoomOverview/Content/useContentPages';
import {
  extractContentIdFromUrl,
  extractSharableIdFromUrl,
} from '../../components/RoomOverview/Content/helper';

const ASSET_TYPES_WITH_COVER = ['AudioMedia', 'VideoMedia'];

const useShowCover = ({
  content,
  isAssetHubContent,
  documentCoverEditable,
  isInlineIframeViewerEnabled,
}: {
  content: any;
  isAssetHubContent: boolean;
  documentCoverEditable: boolean | undefined;
  isInlineIframeViewerEnabled: boolean;
}) => {
  const { asset } = useContext(RoomAssetsContext);
  const { fetchMediaPages } = useContentPages();
  useEffect(() => {
    if (isAssetHubContent && isInlineIframeViewerEnabled) {
      const sharableId = extractSharableIdFromUrl(content.url?.url ?? '');
      fetchMediaPages(
        sharableId ?? '',
        content.mtData?.contentId ??
          extractContentIdFromUrl(content.url?.url ?? '') ??
          ''
      );
    }
  }, [
    fetchMediaPages,
    content.url?.url,
    content.mtData?.contentId,
    isAssetHubContent,
    isInlineIframeViewerEnabled,
  ]);
  const showCover =
    !isInlineIframeViewerEnabled ||
    documentCoverEditable ||
    ASSET_TYPES_WITH_COVER.some(
      (type) => type === asset?.assetDetails?.file?.media?.__typename
    );
  return { showCover, asset };
};

export default useShowCover;
